import ToastView from "keno/app/views/Toast";
import LatestTokenActivityView from "keno/app/views/LatestTokenActivity";
import { globalDisplayQueue } from "keno/app/modules/DisplayQueue";
import EventsMixin from "keno/app/mixins/events";

let openViewsPromise;
let openViewsPromiseResolve;
const openViews = [];
const openViewShowFuncs = [];

const viewClosed = function ( view ) {
	const index = openViews.indexOf( view );

	if( index > -1 ) {
		openViews.splice( index, 1 );
        // list is empty, so we can resolve the promise for all messages now
        // and the queue should move on
		if( openViews.length === 0 ) {
			this.fireEvent( this.EVENTS.MESSAGES_SHOWN );
			if( openViewsPromiseResolve ) {
				const resolve = openViewsPromiseResolve;

				openViewsPromise = null;
				openViewsPromiseResolve = null;
				resolve();
			}
        // otherwise, show the next message/view
		} else {
			openViewShowFuncs.shift()();
		}
	}
};
const enqueueView = function () {
	const view = arguments[0];
	const viewShow = view.show.bind( ...arguments );
	const doQueue = openViews.length === 0 && !openViewsPromise;

	openViews.push( view );
	openViewShowFuncs.push( viewShow );
	view.addEvent( view.EVENTS.CLOSED, viewClosed.bind( this, view ), true );

    // if this is the first view in our list, set the queue position
    // and create our promise, otherwise second/subsequent messages are
    // just appended to the list, and the original promise will resolve
    // once the list empties
	if( doQueue ) {
		openViewsPromise = new Promise(( resolve ) => {
			openViewsPromiseResolve = resolve; 
		});
		globalDisplayQueue.enqueue(() => { 
			openViewShowFuncs.shift()();
			return openViewsPromise; 
		});
	}
};

/**
 * View class responsible for showing the passed in message list
 * one after the other
 *
 * @param object[] An array of messages as returned from the backend UniNavMessages class
 */
const UniNavMessagesView = {
	/**
	 * Show the messages one after the other
	 *
	 * @param object[] Messages list to show as returned by the UniNavMessages backend class
	 *
	 * @return Promise a promise that will resolve once the last message has been shown and closed
	 */
	show: function ( messages, user, opts ) {
		messages = messages || [];
		for ( let i = 0, n = messages.length; i < n; i++ ) {
			switch ( messages[i].type ) {
			case `tokens`:
				this.showTokensMessage( messages[i], user, opts );
				break;
			case `entry`:
				this.showContestEntry( messages[i].text );
				break;
			default:
				this.showToastMessage( messages[i]);
				break;
			}
		}
		return this.onIdle();
	},

	showToastMessage: function ( message ) {
		const toastView = new ToastView(
			`shared/generic-uninav-message.html`,
			message
		);

		enqueueView.call( this, toastView );
	},

	showTokensMessage: function ( message, user, tokenCenterOpts ) {
		const view = new LatestTokenActivityView();

		enqueueView.call( this, view, message, user, tokenCenterOpts );
	},

	showContestEntry: function ( amount ) {
		const view = new ToastView( `shared/entry-confirmed.html`, {
			prizeAmount: amount
		});

		enqueueView.call( this, view );
	},

	showEventContestEntry: function () {
		const view = new ToastView( `shared/promotion-entry-confirmed.html` );

		enqueueView.call( this, view );
	},

	showSweepstakesContestEntry: function ( amount ) {
		const view = new ToastView( `shared/entry-confirmed-sweepstakes.html`, {
			prizeAmount: amount
		});

		enqueueView.call( this, view );
	},

    // Uninav IMessageView impl
    // http://ui.dev.pch.com/docs/uninav/IMessageView.html

	EVENTS: {
		MESSAGES_SHOWN: `onMessagesShown`
	},

	mount: function () {
        // not applicable
	},

	isCurrentMessageShowing: function () {
		return !!openViewsPromise;
	},

	onIdle: function () {
		if( openViewsPromise ) {
			return openViewsPromise;
		}
		return Promise.resolve();
	},

    // returns promise, 
	showMessage: function ( message, doneCallback ) {
		if( !Array.isArray( message )) {
			message = [ message ];
		}
		const promise = this.show( message, window.PCHUSER, window.PCH.uniExp.tokenCenterOptions );

		if( doneCallback ) {
			promise.then( doneCallback );
		}
		return promise;
	}
};

Object.assign( UniNavMessagesView, EventsMixin );

export default UniNavMessagesView;
